import HetGeluidLayout from './components/layouts/HetGeluidLayout.vue'
import VerstoptSpelLayout from './components/layouts/VerstoptSpelLayout.vue'

const CAMPAIGNS = {
  het_geluid: {
    station: 'qmusic_be',
    component: HetGeluidLayout,
    dataLayer: {
      title: 'Het Geluid App Spel',
      type: 'mystery_sound_voting',
    },
    confetti: {
      colors: ['#ff595e', '#ffca3a', '#8ac926', '#1982c4', '#6a4c93'],
      shapePath:
        'M237.88 270.49c.56-12.02 8.36-20.73 18.66-20.73s18.66 9.28 18.66 20.73c0 1.91-.23 3.74-.55 5.52-.79 5.12-5.14 16.96-18.3 31.99-2.21-2.61-4.32-5.17-6.3-7.65-6.18-7.72-12.73-17.83-12.17-29.86m218.7-143.37-.18-.95c-.16-.86-.33-1.71-.5-2.57-4.37-21.25-12.54-40.88-24.31-57.88-13.45-19.42-31.33-34.98-53.14-46.28C357.08 8.39 332.92 1.97 306.64.39c-12.02-.72-24.42-.43-36.87.88-44.15 4.64-89.05 21.52-133.43 50.18C49.28 107.66-2.72 197.9.11 275.31c.84 21.64 5.97 42.26 15.82 60.86 20.16 38.03 54.13 65.2 95.65 76.5 19.78 5.38 40.62 6.97 61.96 4.73 1.03-.11 2.06-.23 3.1-.35 22.97-2.82 45.93-10.05 68.22-21.49 5.73-2.94 11.55-6.52 17.34-10.68 16.15 12.86 31.17 23.76 41.65 31.14 4.91 2.55 10.48 3.65 16.04 3.02 8.11-.64 15.48-5.14 20.2-11.78 4.4-6.19 6.13-13.71 4.87-21.2-1.26-7.49-5.36-14.03-11.55-18.44a869.74 869.74 0 0 1-30.51-22.75l-.17-.14.16-.21c.25-.33.49-.66.73-.98 10.5-14.24 28.04-42.42 27.51-71.18-.43-18.95-7.36-37.28-19.53-51.64-13.78-16.26-32.73-25.49-53.33-26.01-3.07-.08-6.19.05-9.27.37-28.78 3.02-54.26 22.88-63.4 49.41-3.5 10.15-4.98 20.52-4.54 30.85 1.08 22.91 11.67 45.59 30.98 65.13 1.72 1.74 3.5 3.5 5.32 5.29l.23.22-.21.13c-16.65 8.33-33.4 13.43-49.82 15.16-14.16 1.49-27.95.44-41.01-3.11-26.2-7.13-47.63-24.27-60.34-48.26-5.67-10.69-8.72-23.19-9.21-36.85-.77-19.88 3.93-42.23 14.02-65.05 18.73-42.42 52.89-81.17 96.17-109.11C204 75.13 240.51 61.2 275.7 57.5c9.41-.99 18.67-1.22 27.53-.69 35.84 2.16 64.83 16.71 81.63 40.96 7.69 11.1 12.99 24.39 15.73 39.03l.09.48c.11.58.21 1.16.31 1.75.11.64.21 1.29.31 1.93.01.08.03.17.04.25 2.02 13.31 1.96 27.65-.3 42.51-4.86 32.03-19.86 63.82-42.64 90.86-7.71 11.96-5.39 28.05 5.87 37.3 5.92 4.86 13.38 7.5 21.01 6.23 7.48-.64 14.23-4.36 19.01-10.17 30.68-37.38 49.41-80.74 54.18-125.44 1.99-19.12 1.32-37.76-1.89-55.38',
      shapeMatrix: [0.07, 0, 0, 0.07, 0, 0],
      shapeColor: '#ed3624',
    },
    copy: {
      voteQuestion: (guess, name) =>
        `Denk jij dat: "<span class="font-bold">${guess}</span>" van ${name} het juiste antwoord is?`,
      voteButton: 'Ja, dit is Het Geluid!',
      confirmTitle: 'Weet je het zeker?',
      confirmText: "Denk je zeker te weten dat dit Het\u00A0Geluid is?<br />Let op: Je hebt maar één 'JA' per dag.",
      confirmCancel: 'Nee, toch niet',
      confirmSubmit: 'Ja, ik ben zeker',
      errorTitle: 'Oeps! Er ging wat mis...',
      errorText: "Helaas is er iets misgegaan bij het versturen van je 'JA'.",
      errorButton: 'Opnieuw proberen',
      voted:
        "Jouw 'JA' is geregistreerd!<br /><br />Als dit inderdaad Het\u00A0Geluid is, deel jij mee in de extra prijzenpot van €10.000,-.",
      correct: (name) =>
        `Gefeliceerd! Het antwoord van ${name} is goed. Jij deelt mee in de extra prijzenpot van €10.000,-.<br /><br />We nemen zo snel mogelijk contact met je op.`,
      correctButton: 'Meer confetti!',
      incorrect: (name, nextVoteText) =>
        `Helaas, het antwoord van ${name} was niet goed. Daarmee is jouw 'JA' voor vandaag verspeeld.<br /><br />${nextVoteText} vanaf 09:30 uur mag je weer meespelen met het app-spel.`,
      alreadyVoted: (nextVoteText) =>
        `Je hebt vandaag al meegedaan met het app-spel. Je hebt slechts één 'JA' per dag. ${nextVoteText} kan je weer meedoen.`,
      expired: 'Helaas, de tijd is om!<br />Probeer het de volgende ronde opnieuw.',
      countdownPrefix: 'Je hebt nog',
      countdownSecond: 'seconde',
      countdownSeconds: 'seconden',
    },
  },

  verstopt_spel_nl: {
    station: 'joe_nl',
    component: VerstoptSpelLayout,
    dataLayer: {
      title: 'Verstopt Spel App Spel',
      type: 'mystery_sound_voting',
    },
    confetti: {
      colors: ['#ff595e', '#ffca3a', '#8ac926', '#1982c4', '#6a4c93'],
      shapePath: null,
      shapeMatrix: null,
      shapeColor: null,
    },
    copy: {
      voteQuestion: (guess, name) =>
        `Denk jij dat: "<span class="font-bold">${guess}</span>" van ${name} de juiste locatie is?`,
      voteButton: 'Ja, ik klop ook aan!',
      confirmTitle: 'Weet je het zeker?',
      confirmText:
        'Denk je zeker te weten dat dit de juiste locatie is?<br />Let op: je hebt maar één kans per dag om op deze knop te drukken.',
      confirmCancel: 'Nee, toch niet',
      confirmSubmit: 'Ja, ik weet het zeker',
      errorTitle: 'Oeps! Er ging wat mis...',
      errorText: 'Helaas is er iets misgegaan. Probeer het opnieuw.',
      errorButton: 'Opnieuw proberen',
      voted:
        "Jouw 'JA' is geregistreerd!<br /><br />Als dit inderdaad de juiste locatie is, dan maak je kans op €1.000! De winnaar wordt door de computer geselecteerd en wordt gecontacteerd door onze redactie.",
      correct: () =>
        'Gefeliciteerd! Dit was inderdaad de juiste locatie.<br /><br />De winnaar wordt door de computer geselecteerd en gecontacteerd door onze redactie.',
      correctButton: 'Meer confetti!',
      incorrect: (_name, nextVoteText) =>
        `Helaas, dit was niet de juiste locatie. Daarmee is jouw kans voor vandaag verspeeld.<br /><br />${nextVoteText} mag je weer meedoen.`,
      alreadyVoted: (nextVoteText) =>
        `Je hebt vandaag al meegedaan. Je hebt slechts één kans per dag. ${nextVoteText} kan je weer meedoen.`,
      expired: 'Helaas, de tijd is om!<br />Probeer het de volgende ronde opnieuw.',
      countdownPrefix: 'Je hebt nog',
      countdownSecond: 'seconde',
      countdownSeconds: 'seconden',
    },
  },
}

const DEFAULT_CAMPAIGN = 'het_geluid'

function findCampaignByStation(station) {
  return Object.keys(CAMPAIGNS).find((key) => CAMPAIGNS[key].station === station)
}

export function resolveCampaign(search) {
  const params = new URLSearchParams(search)
  const stationParam = params.get('station')
  const campaignParam = params.get('campaign')
  const name =
    (stationParam && findCampaignByStation(stationParam)) ||
    (CAMPAIGNS[campaignParam] ? campaignParam : null) ||
    DEFAULT_CAMPAIGN
  return {
    CAMPAIGN_NAME: name,
    CAMPAIGN_CONFIG: CAMPAIGNS[name],
    IS_STAGING: params.get('env') === 'staging',
  }
}

const resolved = resolveCampaign(window.location.search)
export const CAMPAIGN_NAME = resolved.CAMPAIGN_NAME
export const CAMPAIGN_CONFIG = resolved.CAMPAIGN_CONFIG
export const IS_STAGING = resolved.IS_STAGING
